.wrapper {
  list-style: none;
  box-sizing: border-box;
  padding-left: calc(var(--spacing) * 1.75);
  margin-bottom: -1px;
  --vertical-padding: 10px;
  cursor: pointer;

  &.clone {
    display: inline-block;
    pointer-events: none;
    padding: 5px 0 0 10px;

    .treeItem {
      --vertical-padding: 5px;

      padding-right: 24px;
      border-radius: 4px;
      box-shadow: 0 15px 15px 0 rgb(34, 33, 81, 0.1);
    }
  }

  .selected {
    background-color: var(--color-grey-7) !important;
  }
}

.treeItem {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--vertical-padding) 10px;
  box-sizing: border-box;

  &:hover {
    background-color: rgb(255, 255, 255, 0.06);
  }
}

.collapse {
  svg {
    transition: transform 250ms ease;
    transform: rotate(90deg);
  }

  &.collapsed svg {
    transform: rotate(0deg);
  }

  &.hidden {
    visibility: hidden;
  }
}
